var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJewelry3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_jewelry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "jewelry_x5F_1_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#A5683E",
    points: "266.1,411.4 263.9,347.6 263,335.7 262,335.4 262,349.2 264.1,411.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M262.4,328.6c-9.4,0-17,8.9-17,19.9s7.6,19.9,17,19.9s17-8.9,17-19.9 C279.5,337.5,271.8,328.6,262.4,328.6z M262.4,365.5c-7.7,0-13.9-7.6-13.9-17.1s6.2-17.1,13.9-17.1c7.7,0,13.9,7.6,13.9,17.1 S270.1,365.5,262.4,365.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD74",
    d: "M248.7,351.3l-2.6,2.9c0.5,2.1,1.3,4,2.4,5.8l2.2-2.3C249.7,355.7,249,353.6,248.7,351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M262.4,328.6c-9.4,0-17,8.9-17,19.9c0,2,0.3,3.9,0.7,5.6l2.6-2.9c-0.1-0.9-0.2-1.9-0.2-2.8 c0-9.4,6.2-17.1,13.9-17.1c7.7,0,13.9,7.6,13.9,17.1s-6.2,17.1-13.9,17.1c-4.9,0-9.3-3.2-11.7-7.9l-2.2,2.3 c3.1,5.1,8.2,8.5,13.9,8.5c9.4,0,17-8.9,17-19.9C279.5,337.5,271.8,328.6,262.4,328.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M262.1,311.9c-0.1,0.2-0.1,0.5,0,0.7c2.5,0.3,4.5,3.4,4.5,7.2c0,4-2.2,7.2-5,7.2s-5-3.2-5-7.2 c0-1.5,0.3-2.9,0.9-4.1c-0.3-0.4-0.6-0.8-0.8-1.3c-1.3,1.6-2.2,3.8-2.2,6.3c0,4.8,3.2,8.8,7.2,8.8s7.2-3.9,7.2-8.8 C269.1,315.9,266,312.1,262.1,311.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#469160",
    cx: 265,
    cy: 410.9,
    rx: 3.1,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#469160",
    cx: 262.2,
    cy: 334.7,
    rx: 2.5,
    ry: 3.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#469160",
    d: "M262.2,331.5c-1.4,0-2.5,1.4-2.5,3.2v0.1l3.9-2.8C263.2,331.7,262.7,331.5,262.2,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80F3A7",
    d: "M264.7,334.7c0-1.1-0.5-2.1-1.2-2.7l-3.9,2.8c0,1.2,0.6,2.2,1.4,2.7l3.7-2.6 C264.7,334.8,264.7,334.7,264.7,334.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#469160",
    d: "M261.1,337.5c0.3,0.2,0.7,0.4,1.1,0.4c1.3,0,2.4-1.3,2.5-3L261.1,337.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M256.7,319.8c0-1.5,0.3-2.9,0.9-4.1c-0.3-0.4-0.6-0.8-0.8-1.3c-1.3,1.6-2.2,3.8-2.2,6.3 c0,0.2,0,0.5,0,0.7l2.1-1C256.7,320.2,256.7,320,256.7,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5683E",
    d: "M262.1,311.9c-0.1,0.2-0.1,0.5,0,0.7c2.5,0.3,4.5,3.4,4.5,7.2c0,4-2.2,7.2-5,7.2c-1.3,0-2.5-0.7-3.4-1.9 l-1.7,1.7c1.3,1.7,3.2,2.7,5.2,2.7c4,0,7.2-3.9,7.2-8.8C269.1,315.9,266,312.1,262.1,311.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAD74",
    d: "M256.7,320.4l-2.1,1c0.1,2.1,0.9,4,2,5.4l1.7-1.7C257.4,323.9,256.8,322.2,256.7,320.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#80F3A7",
    d: "M262.7,413.6c0.6,0.9,1.4,1.5,2.3,1.5c1.7,0,3.1-1.9,3.1-4.3c0-0.9-0.2-1.8-0.6-2.5 C265.7,409.8,264.1,411.7,262.7,413.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFAD74",
    points: "263.9,347.9 262,349.5 262.2,356.9 264.2,355.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFAD74",
    points: "265.1,383.4 263.2,384.9 263.5,392.6 265.4,391  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJewelry3);
export default __webpack_public_path__ + "static/media/jewelry_3.6992ebe97308c3bd4b9d3ac02f0f033a.svg";
export { ForwardRef as ReactComponent };